<template>
	<label class="form-field--password"><span v-html="label"/>
		<div class="form-field--password__input">
			<input
				:type="type" :value="value" @change="onChange" @input="onInput"/>
			<button
				v-if="!show"
				class="form-field--password__input__show" tabindex="-1" @click.prevent="switchDisplay()">Show password
			</button>
			<button
				v-else
				class="form-field--password__input__hide" tabindex="-1" @click.prevent="switchDisplay()">Hide password
			</button>
		</div>
		<div v-if="error" class="error-block">
			<p v-html="error"/>
		</div>
	</label>
</template>

<script>
export default {
	name: "FormFieldPassword",

	data() {
		return {
			show: false,
		};
	},

	props: {
		label: {
			type: String,
			default() {
				return "Password";
			},
		},
		value: {
			required: true,
			type: String,
		},
		error: {
			required: false,
			type: String,
		},
	},

	computed: {
		type() {
			return this.show ? "text" : "password";
		},
	},

	methods: {
		onInput(event) {
			// Can add validation here
			this.$emit("input", event.target.value);
		},
		onChange(event) { // Supports .lazy
			// Can add validation here
			this.$emit("change", event.target.value);
		},
		switchDisplay() {
			this.show = !this.show;
		},
	},
};
</script>
